<template>
  <div class="pj-thumb" :class="{ 'pj-thumb--logo': isLogo, 'pj-thumb--small': small }">
    <img v-if="src" :src="src" :alt="alt" loading="lazy" @error="broken = true" />
    <i v-else class="fal fa-image"></i>
  </div>
</template>

<script>
// Imagem do projeto como na edição antiga (hero da landing); sem ela, o logo da instituição; sem nenhuma, um ícone.
export default {
  name: "EditorProjectThumb",
  props: {
    project: { type: Object, required: true },
    small: Boolean,
  },
  data() {
    return { broken: false };
  },
  computed: {
    src() {
      if (this.broken) return null;
      return this.project.heroImagePath || this.project.institutionLogoPath || null;
    },
    isLogo() {
      return !!this.src && !this.project.heroImagePath;
    },
    alt() {
      return this.project.shortName || this.project.fullName || "";
    },
  },
  watch: {
    "project.projectId"() {
      this.broken = false;
    },
  },
};
</script>

<style scoped>
.pj-thumb {
  flex: 0 0 auto;
  width: 132px;
  height: 88px;
  border-radius: 8px;
  overflow: hidden;
  background: #f1f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c3c6d5;
  font-size: 22px;
}
.pj-thumb--small {
  width: 72px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
}
.pj-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.pj-thumb--logo {
  background: #fff;
  border: 1px solid var(--ced-border, #e3e5ec);
}
.pj-thumb--logo img {
  object-fit: contain;
  padding: 8px;
}
@media (max-width: 600px) {
  .pj-thumb:not(.pj-thumb--small) {
    width: 100%;
    height: 140px;
  }
}
</style>
